import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/equipment/tireCrushing/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/equipment/tireCrushing/detail',
    method: 'get',
    params: data,
  })
}
export async function createData(data) {
  return request({
    url: '/equipment/tireCrushing/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/equipment/tireCrushing/edit',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/equipment/tireCrushing/delete',
    method: 'post',
    data,
  })
}
